export default {
	logo: 'Let\'s GO - 學校小助手',
	navBar: {
		active: '0',
		list:[{
				name: '首頁',
				subActive: '0',
				submenu: [{
						icon: "el-icon-s-home",
						name: "後台首頁",
						pathname:'index'
					},
					{
						icon: "el-icon-s-fold",
						name: "相册管理",
						pathname:'image'
					},
					{
						icon: "el-icon-s-fold",
						name: "商品列表",
						pathname:'shop_goods_list'
					}
				]
			},
			{
				name: '商品',
				subActive: '0',
				submenu: [{
					icon: "el-icon-s-fold",
					name: "分類管理",
					pathname:'shop_category'
				},
				{
					icon: "el-icon-s-fold",
					name: "商品列表",
					pathname:'shop_goods_list'
				}
				]
			},
			{
				name: '订單',
				subActive: '0',
				submenu: []
			},
			{
				name: '会员',
				subActive: '0',
				submenu: []
			},
			{
				name: '设置',
				subActive: '0',
				submenu: [
					{
						icon: "el-icon-s-fold",
						name: "基础设置",
						pathname:'set_base'
					},
					{
						icon: "el-icon-s-fold",
						name: "物流设置",
						pathname:'set_express'
					},
					{
						icon: "el-icon-s-fold",
						name: "角色管理",
						pathname:'set_manager'
					}
				
				]
			}
		]
	}
}
